import { z } from "zod";
import { frazioneMerceologicaSchema, causaleAnomaliaSchema } from "./common.js";
export const kpiFiltersSchema = z.object({
    zona_id: z.string().uuid().optional(),
    frazione: frazioneMerceologicaSchema.optional(),
    data_da: z.string().optional(),
    data_a: z.string().optional(),
    operatore_id: z.string().uuid().optional(),
});
export const kpiResponseSchema = z.object({
    totale_rilevazioni: z.number().int(),
    ok: z.number().int(),
    parziali: z.number().int(),
    non_conformi: z.number().int(),
    percentuale_conformita: z.number(),
    anomalie_per_causale: z.array(z.object({
        causale: causaleAnomaliaSchema,
        count: z.number().int(),
    })),
    per_frazione: z.array(z.object({
        frazione: frazioneMerceologicaSchema,
        totale: z.number().int(),
        ok: z.number().int(),
        non_conformi: z.number().int(),
    })),
    time_series: z.array(z.object({
        giorno: z.string(),
        totale: z.number().int(),
        ok: z.number().int(),
        non_conformi: z.number().int(),
    })),
});
export const nonConformiFiltersSchema = z.object({
    zona_id: z.string().uuid().optional(),
    causale: causaleAnomaliaSchema.optional(),
    data_da: z.string().optional(),
    data_a: z.string().optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const mancataEsposizioneSchema = z.object({
    id: z.string().uuid(),
    utenza_id: z.string().uuid(),
    codice_tari: z.string(),
    intestatario: z.string(),
    indirizzo: z.string(),
    zona_id: z.string().uuid(),
    frazione_merceologica: frazioneMerceologicaSchema,
    data_attesa: z.string(),
    calcolato_il: z.string().datetime(),
});
export const mancateEsposizioniFiltersSchema = z.object({
    utenza_id: z.string().uuid().optional(),
    zona_id: z.string().uuid().optional(),
    frazione: frazioneMerceologicaSchema.optional(),
    data_da: z.string().optional(),
    data_a: z.string().optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=reporting.js.map